import axios from 'api/axios'
import { ClientWallet } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for create Wallet Transaction
 */

export interface WalletTransactionBody {
	amount: number
	transactionType: 'DEBIT' | 'CREDIT'
	remarks: string
	taxation: boolean
}

/**
 * API call for create Wallet Transaction
 * @param body WalletTransactionBody - data to be send to backend for create Wallet Transaction
 * @returns WalletTransactionResponse - Response object returned from the server
 */

export const makeWalletTransaction = async (
	id: string,
	body: WalletTransactionBody
) => {
	try {
		const { data } = await axios.post<ClientWallet>(`client/${id}/wallet`, body)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default makeWalletTransaction
